import axiosInstance from '../axios/axiosInstance';
import { API_GET_USER_INF } from 'config/data';
import { Colaborator } from 'model/response';
import { fetchApiGet } from 'utils/helper';

export const SYS_USER_PAGE_SIZE = 8
export const getUserInf = async (): Promise<any> => {
  return await fetchApiGet(API_GET_USER_INF);
};

export const getColaborators = async (typeColaborator: string) => {
  const { data } = await axiosInstance.get<Colaborator[]>(`/user/colaborators/type/${typeColaborator}`);
  return data;
}

export const getSysUsers = async (url?: string) => {
  let api = url ? url : '/user/sys-users';
  const { data } = await axiosInstance.get(api)
  return data;
}

export const createSysUsers = async (payload: any) => {
  const { data } = await axiosInstance.post('/user/sys-user/create',payload)
  return data;
}

export const updateUser = async(userId:string,payload: any) => {
  const { data } = await axiosInstance.put(`/user/sys-user/${userId}`,payload)
  return data;
}

export const toggleUserActive = async (id: string) => {
  await axiosInstance.patch(`user/${id}/toggle-active`);
};